import React from "react";
import PropTypes from "prop-types";
import { MuiThemeProvider } from "@material-ui/core";
import MaterialTable from "material-table";
import TableTheme from "./TableTheme";
import Scrollbars from "components/Scrollbars/Scrollbars";

function AdminTableWrapper(props) {
  const {
    tableIcons,
    isLoading,
    columns,
    data,
    emptyMessage,
    isRowSelected,
    detailPanel,
    className,
    ...rest
  } = props;

  return (
    <MuiThemeProvider theme={TableTheme}>
      <div className={`admin-table-wrapper ${className}`}>
        <Scrollbars>
          <MaterialTable
            localization={{
              body: { emptyDataSourceMessage: <p>{emptyMessage}</p> },
            }}
            icons={tableIcons}
            columns={columns}
            data={data}
            options={{
              search: true,
              paging: false,
              sorting: true,
              draggable: false,
              filtering: false,
              selection: true,
              showTitle: false,
              toolbar: false,
              rowStyle: (row) => {
                return {
                  backgroundColor: isRowSelected(row) ? "#2684ff14" : "#fff",
                };
              },
            }}
            detailPanel = {detailPanel}
            isLoading={isLoading}
            {...rest}
          />
        </Scrollbars>
      </div>
    </MuiThemeProvider>
  );
}

AdminTableWrapper.propTypes = {
  isRowSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
};

AdminTableWrapper.defaultProps = {
  emptyMessage: "No data.",
  detailPanel: undefined,
  className: ""
};

export default AdminTableWrapper;
